import React from "react";
import PropTypes from "prop-types";

export default class OptionCheckBox extends React.Component {
    render(){
        return(
            <div className="form-check sidebar-option">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={this.props.checked}
                    id={this.props.name}
                    value={this.props.value}
                    onClick={(props)=>{
                        this.props.onClick(props);
                    }}
                />
                <label htmlFor={this.props.name}>{this.props.name}</label>
            </div>
        );
    }
}

OptionCheckBox.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired
    ]),
    checked: PropTypes.bool,
    onClick: PropTypes.func
};
